export default "__VITE_ASSET__22e100eb__"